export default __webpack_public_path__ + "static/media/get-ocr-text.8d6a885c.gif";